import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-DuplicateCollections',
	isLoading: 'c-DuplicateCollections--IsLoading',
	content: 'c-DuplicateCollections__Content',
	menu: 'c-DuplicateCollections__Menu',
};

export const Style = {
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.content]: {
		display: 'flex',
		'align-items': 'baseline',
		'justify-content': 'space-around',
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
